import { type FileToUpload } from '@capsicum/common';
import { atomWithReducer } from 'jotai/utils';

export type SourceOfIncomeCategoryState = {
	[category: string]: {
		requirements?: {
			[requirement: string]: Array<FileToUpload>;
		};
		title: string;
	};
};

type SourceOfIncomeAtomAction =
	| {
			category: string;
			files: Array<FileToUpload>;
			requirement: string;
			type: 'SET_FILES';
	  }
	| { category: string; title: string; type: 'ADD_CATEGORY' }
	| { category: string; type: 'REMOVE_CATEGORY_FILES' }
	| { category: string; type: 'REMOVE_CATEGORY' }
	| { type: 'RESET' };

const initialState: SourceOfIncomeCategoryState = {};

const reducer = (state: SourceOfIncomeCategoryState, action: SourceOfIncomeAtomAction): SourceOfIncomeCategoryState => {
	switch (action.type) {
		case 'RESET':
			return {};
		case 'ADD_CATEGORY':
			return {
				...state,
				[action.category]: state[action.category] || { title: action.title }
			};
		case 'REMOVE_CATEGORY': {
			const { [action.category]: _, ...rest } = state;

			return rest;
		}
		case 'REMOVE_CATEGORY_FILES': {
			const { category } = action;

			if (!state[category]) return state;

			const categoryState = state[category];

			delete categoryState.requirements;

			const updatedState = {
				...state,
				[category]: {
					...categoryState
				}
			};

			return updatedState;
		}
		case 'SET_FILES': {
			const { category, files, requirement } = action;

			if (!state[category]) return state;

			const categoryState = state[category];
			const updatedRequirements = { ...categoryState.requirements };

			if (files.length === 0) {
				delete updatedRequirements[requirement];
			} else {
				updatedRequirements[requirement] = files;
			}

			return {
				...state,
				[category]: {
					...categoryState,
					requirements: updatedRequirements
				}
			};
		}
		default:
			return state;
	}
};

export const sourceOfIncomeAtom = atomWithReducer(initialState, reducer);
